<template>
    <!-- The left column of the sell view is still entirely Angular, so everything Vue renders there goes
         through SellLeft. -->
    <Teleport to="#sell-view-left-container">
        <SellLeft />
    </Teleport>

    <Teleport to="#sell-right">
        <div id="sell-view">
            <SellItems />
        </div>
    </Teleport>
</template>

<script>
import SellItems from '@/epos/vue/pages/sell/components/SellItems';
import SellLeft from '@/epos/vue/pages/sell/components/SellLeft';

/**
 * Important!
 * This is not the entire controller for the sell view. The majority of that is Angular and is run by SellCtrl.
 * This is small Vue app that is mounted isnside SellView so we can start incrementally converting the page to Vue,
 * instead of needing to convert it all at once.
 */
export default {
    components: {
        SellItems,
        SellLeft,
    },
};
</script>

<style lang="less">
#sell-view {
    // Fill all the vertical space in the right column.
    flex-grow: 1;
    height: 100%;

    display: flex;
    flex-direction: column;
}
</style>
